"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconDocumentUpload = function SvgIconDocumentUpload(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "document upload icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Document Upload Icon'), /*#__PURE__*/_react.default.createElement("style", null, '.icon_document_upload_svg__icon_document_upload_svg__st0{fill-rule:evenodd;clip-rule:evenodd}'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.2 27.7c.7 0 1.3.1 1.9.2.4.1.8-.2.8-.6V16.7l-11-11.1H12.1c-2 0-3.6 1.7-3.6 3.7v25.8c0 2 1.6 3.7 3.6 3.7h12.2c.5 0 .9-.5.8-1-.1-.6-.2-1.1-.2-1.8 0-4.6 3.7-8.3 8.3-8.3zM23.1 8.3l10.1 10.1H23.1V8.3z",
    className: "icon_document_upload_svg__icon_document_upload_svg__st0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.2 29.5c-3.5 0-6.4 2.9-6.4 6.5s2.9 6.5 6.4 6.5c3.5 0 6.4-2.9 6.4-6.5s-2.9-6.5-6.4-6.5zm3.6 7.3l-3.2-3.2v6.2h-1.1v-6l-3 3-.8-.8 4.4-4.4 4.4 4.4-.7.8z",
    className: "icon_document_upload_svg__icon_document_upload_svg__st0"
  }));
};

var _default = SvgIconDocumentUpload;
exports.default = _default;